import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const features = [
  { icon: 'Home', text: 'Historic Spanish Revival architecture' },
  { icon: 'Sun', text: 'Romantic terrace ceremony spaces' },
  { icon: 'Coffee', text: 'Indoor reception spaces' },
  { icon: 'Coffee', text: 'Catering and bar service available' },
  { icon: 'Zap', text: 'Event lighting and on-site support' },
  { icon: 'Camera', text: 'Scenic photo locations throughout the venue' },
];

const FeaturesSection = () => {
  return (
    <section className="py-24 bg-padua-ivory relative border-b border-padua-gold/10">
      <div className="absolute inset-0 bg-tile-pattern pointer-events-none opacity-40" />
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-3xl md:text-5xl font-serif text-padua-charcoal mb-6">Why Couples Choose Padua</h2>
          <div className="w-24 h-0.5 bg-padua-gold mx-auto" />
        </motion.div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group flex flex-col items-center text-center p-10 bg-padua-cream/50 rounded-2xl border border-padua-gold/10 hover:border-padua-gold/30 hover:bg-white transition-all duration-500 shadow-sm"
            >
              <div className="mb-6 w-16 h-16 rounded-full bg-padua-olive/5 flex items-center justify-center text-padua-olive group-hover:bg-padua-olive group-hover:text-padua-ivory transition-all duration-500">
                <SafeIcon name={feature.icon} className="w-7 h-7" />
              </div>
              <p className="text-lg text-padua-charcoal font-medium leading-snug">
                {feature.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;